import { filter } from './filter.js';
import { propertyFilter } from './property-filter.js';
import { sort } from './sort.js';
import { getPagesCount, normalizePageIndex, paginate } from './paginate.js';
export function processItems(items, _a, _b) {
    var filteringText = _a.filteringText, sortingState = _a.sortingState, currentPageIndex = _a.currentPageIndex, propertyFilteringQuery = _a.propertyFilteringQuery;
    var filtering = _b.filtering, sorting = _b.sorting, pagination = _b.pagination, propertyFiltering = _b.propertyFiltering;
    var result = items;
    var pagesCount;
    var actualPageIndex;
    var filteredItemsCount;
    if (propertyFiltering) {
        result = propertyFilter(result, propertyFilteringQuery || { tokens: [], operation: 'and' }, propertyFiltering);
        filteredItemsCount = result.length;
    }
    if (filtering) {
        result = filter(result, filteringText, filtering);
        filteredItemsCount = result.length;
    }
    if (sorting) {
        result = sort(result, sortingState);
    }
    var allPageResult = result;
    if (pagination) {
        pagesCount = getPagesCount(result, pagination.pageSize);
        actualPageIndex = normalizePageIndex(currentPageIndex, pagesCount);
        result = paginate(result, actualPageIndex, pagination.pageSize);
    }
    return { items: result, allPageItems: allPageResult, pagesCount: pagesCount, filteredItemsCount: filteredItemsCount, actualPageIndex: actualPageIndex };
}
export var getTrackableValue = function (trackBy, item) {
    if (!trackBy) {
        return item;
    }
    if (typeof trackBy === 'function') {
        return trackBy(item);
    }
    return item[trackBy];
};
export var processSelectedItems = function (items, selectedItems, trackBy) {
    var selectedSet = new Set();
    selectedItems.forEach(function (item) { return selectedSet.add(getTrackableValue(trackBy, item)); });
    return items.filter(function (item) { return selectedSet.has(getTrackableValue(trackBy, item)); });
};
export var itemsAreEqual = function (items1, items2, trackBy) {
    if (items1.length !== items2.length) {
        return false;
    }
    var set1 = new Set();
    items1.forEach(function (item) { return set1.add(getTrackableValue(trackBy, item)); });
    return items2.every(function (item) { return set1.has(getTrackableValue(trackBy, item)); });
};
